import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgArrowRightOutline = function SvgArrowRightOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4697 5.21967C13.7626 4.92678 14.2374 4.92678 14.5303 5.21967L20.7803 11.4697C21.0732 11.7626 21.0732 12.2374 20.7803 12.5303L14.5303 18.7803C14.2374 19.0732 13.7626 19.0732 13.4697 18.7803C13.1768 18.4874 13.1768 18.0126 13.4697 17.7197L18.4393 12.75H3.75C3.33579 12.75 3 12.4142 3 12C3 11.5858 3.33579 11.25 3.75 11.25H18.4393L13.4697 6.28033C13.1768 5.98744 13.1768 5.51256 13.4697 5.21967Z"
  })));
};

export { SvgArrowRightOutline as ReactComponent };
//# sourceMappingURL=arrow-right-outline.svg.js.map
